<div class="card_view_wrap">
  @for (year of yearsList; track year) {
    <div class="year_title_wrap">
      <h3 class="title_24">
        {{ "DASHBOARD.TAX_YEAR_TITLE" | translate }} <strong>{{ year.year }}</strong> ({{ year.qty }})
      </h3>
      <button class="visible-xs" (click)="expandYearList(year)" mat-icon-button>
        @if (!year.active) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (year.active) {
          <mat-icon>expand_less</mat-icon>
        }
      </button>
    </div>
    <div class="year_lists" [class.active]="year.active">
      @for (statement of statements; track statement; let i = $index) {
        @if (statement.fullYear === year.year) {
          <app-card-view-item
            [statement]="statement"
            (downloadPdf)="emitDownloadPdf(statement)"
            (downloadInvoice)="emitDownloadInvoice(statement)"
            (showDownloadDialog)="emitShowDownloadDialog(statement)"
            (deleteStatement)="emitDeleteStatement(statement, i)"
            (cloneStatement)="emitCloneStatement(statement)"
            >
          </app-card-view-item>
        }
      }
    </div>
  }
</div>
